import React from 'react';
import { LogOut, AlertTriangle } from 'lucide-react';
import { restorePrimaryOperationSession } from '../utils/companyNetworkSession';

export const ImpersonateBanner: React.FC = () => {
  const isImpersonating = localStorage.getItem('superadmin_token_backup') !== null;

  if (!isImpersonating) return null;

  const handleRestore = () => {
    const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const isRouteWithOwnPath = window.location.pathname.startsWith('/marketing')
      || window.location.pathname.startsWith('/chat')
      || window.location.pathname === '/suporte';

    restorePrimaryOperationSession({
      redirectPath: isRouteWithOwnPath ? currentPath : '/dashboard'
    });
  };

  return (
    <div className="w-full bg-purple-600 px-4 py-2 flex items-center justify-center gap-4 shadow-md z-[60] sticky top-0 border-b border-purple-800">
      <div className="flex items-center gap-2 text-white font-medium text-sm">
        <AlertTriangle size={18} className="animate-pulse" />
        Você está em acesso temporário a outra operação. As ações tomadas aqui são reais.
      </div>
      <button 
        onClick={handleRestore} 
        className="bg-white dark:bg-slate-900 text-purple-700 dark:text-purple-300 hover:bg-purple-100 dark:bg-purple-900/40 px-4 py-1.5 rounded-lg text-xs font-bold transition-colors flex items-center gap-2 shadow-sm dark:shadow-slate-900/30 whitespace-nowrap"
      >
        <LogOut size={14} /> Voltar para minha sessão
      </button>
    </div>
  );
};
